import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputComponent } from '../../../components/InputComponent';
import { FileComponent } from '../../../components/FileComponent';
import * as generic from '../../../components/Generico';
import { EmpleadoDeclaracion as EmpleadoDeclaracionModel } from '../../../models/ficha/EmpleadoDeclaracion';
import { EmpleadoService } from '../../../service/EmpleadoService';
import { BottomActionBar } from '../../../components/ui/BottomActionBar';
import { PepAfinidad } from './PepAfinidad';

export const EmpleadoDeclaracion = ({ toast, id, permss, catalogos, handlePrev, mostrarAnexos, soloLectura }) => {

    const omodel = new EmpleadoDeclaracionModel({ tipoFrmEmpresa: catalogos?.tipoFrmEmpresa });
    const defaultValues = generic.funDefault(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, setValue } = useForm({ defaultValues, shouldTrim: true });
    const empleadoService = new EmpleadoService();
    const { inDrop, inText, inCalendar, inArea } = InputComponent({ omodel, errors, control, permss, id, soloLectura });
    const { enviarFormulario } = FileComponent({ tipo: 'empleado', toast, unuevo: 'ficha/empleado/store', udelete: 'ficha/empleado/eliminar-anexo', permss, id });
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [esPep, setEsPep] = useState(false);
    const [esVinculoPep, setEsVinculoPep] = useState(false);

    useEffect(() => {
        editFicha();
        // eslint-disable-next-line
    }, [id]);

    const editFicha = () => {
        setIsLoading(true);
        empleadoService.consultarEmpleado(id, 'seccion4').then(res => {
            const _emp = res.data.empleado;
            if (!_emp) {
                reset(defaultValues);
                setIsLoading(false);
                return;
            }

            if (!_emp.observacion) {
                _emp.observacion = '';
            }

            setEsPep(_emp.es_pep?.cat_id === true);
            setEsVinculoPep(_emp.relacion_pep?.cat_id === true);
            if (_emp.es_pep?.cat_id === true) {
                _emp.fecha_designacion_pep = generic.stringToDate(_emp.fecha_designacion_pep);
                _emp.fecha_dejo_pep = generic.stringToDate(_emp.fecha_dejo_pep);
            }
            if (_emp.relacion_pep?.cat_id === true) {
                _emp.fecha_vinculo_pep = generic.stringToDate(_emp.fecha_vinculo_pep);
                _emp.fecha_culminacion_vinculo_pep = generic.stringToDate(_emp.fecha_culminacion_vinculo_pep);
            }
            reset(generic.renewValues(_emp, omodel.model));
        }).finally(() => setIsLoading(false));
    }

    const onSubmit = (data) => {
        setIsSaving(true);
        data.id = id;
        data.casado = catalogos?.casado;
        data.union = catalogos?.union;
        data.tipoFrmEmpresa = catalogos?.tipoFrmEmpresa;
        data.seccion = 'seccion4';
        if (esPep) {
            data.fecha_designacion_pep = data.fecha_designacion_pep ? generic.dateToString(data.fecha_designacion_pep) : null;
            data.fecha_dejo_pep = data.fecha_dejo_pep ? generic.dateToString(data.fecha_dejo_pep) : null;
        } else {
            delete data.fecha_designacion_pep;
            delete data.fecha_dejo_pep;
        }
        if (esVinculoPep) {
            data.fecha_vinculo_pep = data.fecha_vinculo_pep ? generic.dateToString(data.fecha_vinculo_pep) : null;
            data.fecha_culminacion_vinculo_pep = data.fecha_culminacion_vinculo_pep ? generic.dateToString(data.fecha_culminacion_vinculo_pep) : null;
        } else {
            delete data.fecha_vinculo_pep;
            delete data.fecha_culminacion_vinculo_pep;
        }

        empleadoService.editarEmpleado(data).then(res => {
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    }

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    }

    const onChangePep = (e, esCampoPep) => {
        if (esCampoPep) {
            setEsPep(e.value?.cat_id === true);
            setValue('cargo_pep', '');
            setValue('institucion_pep', '');
            setValue('fecha_designacion_pep', null);
            setValue('fecha_dejo_pep', null);
        } else {
            setEsVinculoPep(e.value?.cat_id === true);
            setValue('vinculo_pep', '');
            setValue('nombre_pep', '');
            setValue('cargo_vinculo_pep', '');
            setValue('institucion_vinculo_pep', '');
            setValue('fecha_vinculo_pep', null);
            setValue('fecha_culminacion_vinculo_pep', null);
        }
    }

    const generarReporte = () => {
        setLoadReport(true);

        empleadoService.descargar(id, { tipoFrmEmpresa: catalogos?.tipoFrmEmpresa }).then(res => {
            generic.downloadPdf(res, `${id}-Formulario-empleado.pdf`);
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const enviar = () => {
        enviarFormulario(id, `ficha/empleado/enviar?tipoFrmEmpresa=${catalogos?.tipoFrmEmpresa ?? ''}`, 'empleado');
    }

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    return (
        <form onSubmit={handleSubmit(onSubmit, onError)} className="p-fluid">

            <Panel header={generic.renderPanelHeader('F', 'PERSONA EXPUESTA POLÍTICAMENTE (PEP)', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-info-circle text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Definición de PEP</span>
                    </div>
                    {omodel.strPep}
                </div>

                <div className="col-12 mb-3 mt-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-user text-primary"></i>
                            CONDICIÓN DE PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid mb-4">
                    {inDrop('es_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: true }, 12)}
                    {esPep && (
                        <>
                            {inText('cargo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_pep', { icon: 'pi pi-building' }, 6)}
                            {inCalendar('fecha_designacion_pep', {}, 6)}
                            {inCalendar('fecha_dejo_pep', { obl: true }, 6)}
                        </>
                    )}
                </div>

                <div className="col-12 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-users text-primary"></i>
                            FAMILIARES O RELACIONADOS
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="col-12 px-0 mb-4">
                    <PepAfinidad tipo='empleado' id={id} toast={toast} permss={permss} catalogos={catalogos} soloLectura={soloLectura} />
                </div>

                <div className="col-12 mt-3 mb-3">
                    <div className="flex align-items-center">
                        <span className="text-800 font-bold text-base mr-3 flex align-items-center gap-2">
                            <i className="pi pi-share-alt text-primary"></i>
                            VÍNCULO CON UN PEP
                        </span>
                        <div className="border-bottom-1 border-300 flex-grow-1" style={{ height: '1px' }}></div>
                    </div>
                </div>

                <div className="formgrid grid">
                    {inDrop('relacion_pep', generic.estadosSiNo, { lab: 'nombre', chn: onChangePep, val: false }, 12)}
                    {esVinculoPep && (
                        <>
                            {inText('vinculo_pep', { icon: 'pi pi-link' }, 6)}
                            {inText('nombre_pep', { icon: 'pi pi-user' }, 6)}
                            {inText('cargo_vinculo_pep', { icon: 'pi pi-briefcase' }, 6)}
                            {inText('institucion_vinculo_pep', { icon: 'pi pi-building' }, 6)}
                            {inCalendar('fecha_vinculo_pep', {}, 6)}
                            {inCalendar('fecha_culminacion_vinculo_pep', { obl: true }, 6)}
                        </>
                    )}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('6', 'DECLARACIÓN', 'pi pi-file-edit')} className="panel-ficha shadow-1 mb-4">
                <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-verified text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Términos de la Declaración</span>
                    </div>
                    {omodel.strDeclaracion}
                </div>
            </Panel>

            <Panel header={generic.renderPanelHeader('7', 'AUTORIZACIÓN PARA TRATAMIENTO DE DATOS', 'pi pi-lock')} className="panel-ficha shadow-1 mb-4">
                <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                    <div className="flex align-items-center gap-2 mb-3">
                        <i className="pi pi-shield text-blue-600 text-lg"></i>
                        <span className="font-bold text-blue-900">Tratamiento de Datos Personales</span>
                    </div>
                    {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && omodel.strAutorizacionTratamientoDatos}
                    {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && omodel.strToyota}
                    {catalogos?.tipoFrmEmpresa === 'FRM_DIFARE' && omodel.strDifare}
                </div>
            </Panel>

            {catalogos?.tipoFrmEmpresa === 'FRM_TOYOTA' && (
                <Panel header={generic.renderPanelHeader('', 'CONSENTIMIENTO PARA EL USO DE DATOS PERSONALES', 'pi pi-shield')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid align-items-center">
                        <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-4">
                            {omodel.strConceder}
                        </div>

                        {inDrop('uso_dato_personal', generic.estadosSiNo, { lab: 'nombre' }, 4)}

                        <div className="field col-8 p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500 mb-0">
                            {omodel.strActividad}
                        </div>
                    </div>
                </Panel>
            )}

            <Panel header={generic.renderPanelHeader('', 'ANEXOS REQUERIDOS', 'pi pi-paperclip')} className="panel-ficha shadow-1 mb-4">
                <div className="formgrid grid">
                    <div className="field col-12 p-3 text-justify line-height-3 text-700 bg-yellow-50 border-round border-left-3 border-yellow-500 mb-0">
                        <div className="flex align-items-center gap-2 mb-3">
                            <i className="pi pi-folder-open text-yellow-600 text-lg"></i>
                            <span className="font-bold text-yellow-900">Documentos que debe adjuntar</span>
                        </div>
                        <ul className="pl-4 m-0">
                            {catalogos?.anexosRequisitos?.map((req, index) => (
                                <li key={index} className="mb-1">{req}</li>
                            ))}
                        </ul>
                    </div>
                </div>
            </Panel>

            {!['FRM_TOYOTA', 'FRM_DIFARE'].includes(catalogos?.tipoFrmEmpresa) && (
                <Panel header={generic.renderPanelHeader('', 'OBSERVACIONES', 'pi pi-comment')} className="panel-ficha shadow-1 mb-4">
                    <div className="formgrid grid">
                        {inArea('observacion', 2, 100, 12)}
                    </div>
                </Panel>
            )}

            <BottomActionBar onPrev={handlePrev} onSave={true} onGenerate={generarReporte} onSend={enviar} onAttachments={mostrarAnexos}
                loading={isSaving || loadReport} isReadOnly={soloLectura} enableExtras={id != null} />
        </form>
    );
}
